var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-insurance-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompany"
    }
  }, [_vm._v("Zdravotní pojišťovna:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "insuranceCompany",
      "data-testid": "registration-insurance-company",
      "props": "options",
      "options": _vm.insuranceCompanies,
      "track-by": "name",
      "label": "name",
      "placeholder": "vybrat pojišťovnu",
      "option-height": 104,
      "open-direction": "down",
      "custom-label": _vm.customLabel,
      "show-labels": false,
      "TagPlaceholder": "",
      "allow-empty": true,
      "selectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          attrs: {
            "data-testid": 'registration-insurance-company-option-' + props.option.code
          }
        }, [_vm._v(_vm._s(_vm.customLabel(props.option)))])]
      }
    }]),
    model: {
      value: (_vm.selectedInsuranceCompany),
      callback: function($$v) {
        _vm.selectedInsuranceCompany = $$v
      },
      expression: "selectedInsuranceCompany"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("Druh: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.type),
      expression: "insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "insuranceType",
      "data-testid": "registration-insurance-step-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.selectedInsuranceCompany === null) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "submit",
      "data-testid": "registration-insurance-skip"
    }
  }, [_vm._v("Přeskočit (bez pojištění)")]) : (_vm.insurancePending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-insurance-save"
    }
  }, [_vm._v("Vybrat zdravotní pojišťovnu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : _vm._e(), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(0)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e5ab86","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Registration/components/RegistrationClientInsurance.vue
// module id = 463
// module chunks = 0